import { render, staticRenderFns } from "./ListAuthorTasks.vue?vue&type=template&id=678b66c6&"
import script from "./ListAuthorTasks.vue?vue&type=script&lang=js&"
export * from "./ListAuthorTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports